export default "__VITE_ASSET__749081b3__"